module.exports = __webpack_public_path__ + "img/p_icon07.d4dda79a.svg";